import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, vModelText as _vModelText, withDirectives as _withDirectives, vModelSelect as _vModelSelect } from "vue"
import _imports_0 from '../../../assets/img/logo.jpg'


const _hoisted_1 = {
  key: 0,
  class: "modal fade show d-block purchase-details-modal",
  tabindex: "-1",
  "aria-modal": "true",
  role: "dialog"
}
const _hoisted_2 = { class: "modal-dialog modal-xl modal-dialog-centered modal-dialog-scrollable purchase-details-dialog" }
const _hoisted_3 = { class: "modal-content border-0 shadow-lg" }
const _hoisted_4 = { class: "modal-header border-0 pb-0 align-items-start" }
const _hoisted_5 = { class: "mb-1" }
const _hoisted_6 = { class: "text-muted mb-0" }
const _hoisted_7 = ["aria-label"]
const _hoisted_8 = { class: "modal-body pt-4" }
const _hoisted_9 = { class: "row g-3 mb-4" }
const _hoisted_10 = { class: "col-md-3 col-sm-6" }
const _hoisted_11 = { class: "summary-card" }
const _hoisted_12 = { class: "summary-label" }
const _hoisted_13 = { class: "col-md-3 col-sm-6" }
const _hoisted_14 = { class: "summary-card" }
const _hoisted_15 = { class: "summary-label" }
const _hoisted_16 = { class: "text-success" }
const _hoisted_17 = { class: "col-md-3 col-sm-6" }
const _hoisted_18 = { class: "summary-card" }
const _hoisted_19 = { class: "summary-label" }
const _hoisted_20 = { class: "text-warning" }
const _hoisted_21 = { class: "col-md-3 col-sm-6" }
const _hoisted_22 = { class: "summary-card" }
const _hoisted_23 = { class: "summary-label" }
const _hoisted_24 = { class: "row g-4" }
const _hoisted_25 = { class: "col-lg-7" }
const _hoisted_26 = { class: "details-panel" }
const _hoisted_27 = { class: "panel-header" }
const _hoisted_28 = { class: "mb-1" }
const _hoisted_29 = { class: "text-muted mb-0" }
const _hoisted_30 = { class: "table-responsive" }
const _hoisted_31 = { class: "table align-middle mb-0" }
const _hoisted_32 = { class: "text-center" }
const _hoisted_33 = { class: "text-end" }
const _hoisted_34 = { class: "text-end" }
const _hoisted_35 = { class: "fw-semibold" }
const _hoisted_36 = { class: "text-muted small" }
const _hoisted_37 = { class: "text-center" }
const _hoisted_38 = { class: "text-end" }
const _hoisted_39 = { class: "text-end fw-semibold" }
const _hoisted_40 = { key: 0 }
const _hoisted_41 = {
  colspan: "6",
  class: "text-center text-muted py-4"
}
const _hoisted_42 = { class: "col-lg-5" }
const _hoisted_43 = { class: "details-panel mb-4" }
const _hoisted_44 = { class: "panel-header" }
const _hoisted_45 = { class: "mb-1" }
const _hoisted_46 = { class: "text-muted mb-0" }
const _hoisted_47 = { class: "payment-list" }
const _hoisted_48 = { class: "fw-semibold" }
const _hoisted_49 = { class: "text-muted small" }
const _hoisted_50 = { key: 0 }
const _hoisted_51 = { class: "text-end" }
const _hoisted_52 = { class: "fw-semibold" }
const _hoisted_53 = { class: "payment-actions mt-2" }
const _hoisted_54 = ["onClick"]
const _hoisted_55 = ["onClick"]
const _hoisted_56 = {
  key: 0,
  class: "payment-empty-state"
}
const _hoisted_57 = { class: "mb-2" }
const _hoisted_58 = { class: "text-muted mb-0" }
const _hoisted_59 = {
  key: 0,
  class: "details-panel"
}
const _hoisted_60 = { class: "panel-header" }
const _hoisted_61 = { class: "mb-1" }
const _hoisted_62 = { class: "text-muted mb-0" }
const _hoisted_63 = { class: "row g-3" }
const _hoisted_64 = { class: "col-md-6" }
const _hoisted_65 = { class: "form-label" }
const _hoisted_66 = { class: "col-md-6" }
const _hoisted_67 = { class: "form-label" }
const _hoisted_68 = { value: null }
const _hoisted_69 = ["value"]
const _hoisted_70 = { class: "col-12" }
const _hoisted_71 = { class: "form-label" }
const _hoisted_72 = ["placeholder"]
const _hoisted_73 = { class: "col-12" }
const _hoisted_74 = { class: "form-label" }
const _hoisted_75 = ["placeholder"]
const _hoisted_76 = { class: "col-12" }
const _hoisted_77 = ["disabled"]
const _hoisted_78 = {
  key: 0,
  class: "spinner-border spinner-border-sm me-2"
}
const _hoisted_79 = { class: "details-panel mt-4" }
const _hoisted_80 = { class: "d-flex justify-content-between align-items-center mb-3" }
const _hoisted_81 = { class: "mb-0" }
const _hoisted_82 = { class: "totals-row" }
const _hoisted_83 = { class: "totals-row" }
const _hoisted_84 = { key: 0 }
const _hoisted_85 = { class: "totals-row" }
const _hoisted_86 = {
  key: 0,
  class: "totals-row"
}
const _hoisted_87 = { class: "totals-row grand" }
const _hoisted_88 = { class: "print-only" }
const _hoisted_89 = { class: "invoice-container" }
const _hoisted_90 = { class: "invoice-header-top d-flex justify-content-between align-items-start mb-40" }
const _hoisted_91 = { class: "invoice-title-box text-end" }
const _hoisted_92 = { class: "invoice-title text-danger fw-bold mb-0" }
const _hoisted_93 = { class: "fs-14 fw-bold text-title mb-0" }
const _hoisted_94 = { class: "invoice-info-section d-flex justify-content-between mb-40" }
const _hoisted_95 = { class: "bill-to" }
const _hoisted_96 = { class: "fs-12 fw-bold text-title mb-1 text-uppercase" }
const _hoisted_97 = { class: "fs-16 fw-bold text-title mb-1 text-uppercase" }
const _hoisted_98 = { class: "fs-12 text-paragraph mb-0" }
const _hoisted_99 = {
  key: 0,
  class: "fs-12 text-paragraph mb-0"
}
const _hoisted_100 = { class: "invoice-summary-box text-end" }
const _hoisted_101 = { class: "fs-14 fw-bold text-title mb-1" }
const _hoisted_102 = { class: "fs-24 fw-bold text-title mb-2" }
const _hoisted_103 = { class: "fs-14 text-title mb-0" }
const _hoisted_104 = { class: "invoice-items-table mb-20" }
const _hoisted_105 = { class: "table mb-0" }
const _hoisted_106 = { class: "bg-light" }
const _hoisted_107 = { class: "py-2 fs-14 fw-bold text-uppercase" }
const _hoisted_108 = { class: "text-center py-2 fs-14 fw-bold text-uppercase" }
const _hoisted_109 = { class: "text-center py-2 fs-14 fw-bold text-uppercase" }
const _hoisted_110 = { class: "text-end py-2 fs-14 fw-bold text-uppercase" }
const _hoisted_111 = { class: "text-end py-2 fs-14 fw-bold text-uppercase" }
const _hoisted_112 = { class: "text-center py-3 fs-14 text-paragraph" }
const _hoisted_113 = { class: "py-3" }
const _hoisted_114 = { class: "fs-14 fw-bold text-title" }
const _hoisted_115 = { class: "text-center py-3 fs-14 text-paragraph" }
const _hoisted_116 = { class: "text-center py-3 fs-14 text-paragraph" }
const _hoisted_117 = { class: "text-end py-3 fs-14 text-paragraph" }
const _hoisted_118 = { class: "text-end py-3 fs-14 fw-bold text-title" }
const _hoisted_119 = { class: "row mb-40" }
const _hoisted_120 = { class: "col-7" }
const _hoisted_121 = { class: "payment-info mb-40" }
const _hoisted_122 = { class: "fs-14 fw-bold text-title mb-3" }
const _hoisted_123 = { class: "fs-12 text-paragraph mb-1" }
const _hoisted_124 = { class: "fw-bold" }
const _hoisted_125 = { class: "fw-bold text-capitalize" }
const _hoisted_126 = { class: "fw-bold" }
const _hoisted_127 = { class: "col-5" }
const _hoisted_128 = { class: "invoice-totals text-end" }
const _hoisted_129 = { class: "d-flex justify-content-between mb-2" }
const _hoisted_130 = { class: "fs-14 fw-bold text-title text-uppercase" }
const _hoisted_131 = { class: "fs-14 text-paragraph" }
const _hoisted_132 = { class: "d-flex justify-content-between mb-2" }
const _hoisted_133 = { class: "fs-14 fw-bold text-title text-uppercase" }
const _hoisted_134 = { key: 0 }
const _hoisted_135 = { class: "fs-14 text-paragraph" }
const _hoisted_136 = { class: "d-flex justify-content-between mb-2" }
const _hoisted_137 = { class: "fs-14 fw-bold text-title text-uppercase" }
const _hoisted_138 = { class: "fs-14 text-paragraph" }
const _hoisted_139 = {
  key: 0,
  class: "d-flex justify-content-between mb-2"
}
const _hoisted_140 = { class: "fs-14 fw-bold text-title text-uppercase" }
const _hoisted_141 = { class: "fs-14 text-paragraph" }
const _hoisted_142 = { class: "d-flex justify-content-between bg-danger text-white p-2 mt-3" }
const _hoisted_143 = { class: "fs-18 fw-bold text-uppercase" }
const _hoisted_144 = { class: "fs-18 fw-bold" }
const _hoisted_145 = { class: "d-flex justify-content-between p-2 mt-1 border-bottom" }
const _hoisted_146 = { class: "fs-14 fw-bold text-title text-uppercase" }
const _hoisted_147 = { class: "fs-14 text-paragraph" }
const _hoisted_148 = { class: "d-flex justify-content-between bg-dark text-white p-2 mt-1" }
const _hoisted_149 = { class: "fs-16 fw-bold text-uppercase" }
const _hoisted_150 = { class: "fs-16 fw-bold" }
const _hoisted_151 = { class: "modal-footer border-0 pt-0" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_ctx.localPurchase)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", {
          class: "modal-backdrop fade show",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('close')))
        }),
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", null, [
                _createElementVNode("span", {
                  class: _normalizeClass(["badge purchase-status-badge mb-2", _ctx.purchaseStatusClass(_ctx.localPurchase.status)])
                }, _toDisplayString(_ctx.formatPurchaseStatus(_ctx.localPurchase.status)), 3),
                _createElementVNode("h4", _hoisted_5, _toDisplayString(_ctx.$t("purchase_page.purchase_label")) + " " + _toDisplayString(_ctx.localPurchase.ref), 1),
                _createElementVNode("p", _hoisted_6, _toDisplayString(_ctx.localPurchase.supplier_name || _ctx.$t("purchase_page.not_available_short")) + " • " + _toDisplayString(_ctx.localPurchase.warehouse_name || _ctx.$t("purchase_page.not_available_short")) + " • " + _toDisplayString(_ctx.formatDate(_ctx.localPurchase.created_at || _ctx.localPurchase.date)), 1)
              ]),
              _createElementVNode("button", {
                type: "button",
                class: "btn-close shadow-none",
                "aria-label": _ctx.$t('common.close'),
                onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('close')))
              }, null, 8, _hoisted_7)
            ]),
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("div", _hoisted_9, [
                _createElementVNode("div", _hoisted_10, [
                  _createElementVNode("div", _hoisted_11, [
                    _createElementVNode("span", _hoisted_12, _toDisplayString(_ctx.$t("purchase_page.grand_total")), 1),
                    _createElementVNode("h5", null, _toDisplayString(_ctx.formatMoney(_ctx.localPurchase.grand_total)), 1)
                  ])
                ]),
                _createElementVNode("div", _hoisted_13, [
                  _createElementVNode("div", _hoisted_14, [
                    _createElementVNode("span", _hoisted_15, _toDisplayString(_ctx.$t("purchase_page.paid")), 1),
                    _createElementVNode("h5", _hoisted_16, _toDisplayString(_ctx.formatMoney(_ctx.localPurchase.paid)), 1)
                  ])
                ]),
                _createElementVNode("div", _hoisted_17, [
                  _createElementVNode("div", _hoisted_18, [
                    _createElementVNode("span", _hoisted_19, _toDisplayString(_ctx.$t("purchase_page.balance_due")), 1),
                    _createElementVNode("h5", _hoisted_20, _toDisplayString(_ctx.formatMoney(_ctx.balanceDue)), 1)
                  ])
                ]),
                _createElementVNode("div", _hoisted_21, [
                  _createElementVNode("div", _hoisted_22, [
                    _createElementVNode("span", _hoisted_23, _toDisplayString(_ctx.$t("purchase_page.payment_status")), 1),
                    _createElementVNode("h5", null, [
                      _createElementVNode("span", {
                        class: _normalizeClass(["badge payment-status-badge", _ctx.paymentStatusClass(_ctx.localPurchase.payment_status)])
                      }, _toDisplayString(_ctx.formatPaymentStatus(_ctx.localPurchase.payment_status)), 3)
                    ])
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_24, [
                _createElementVNode("div", _hoisted_25, [
                  _createElementVNode("div", _hoisted_26, [
                    _createElementVNode("div", _hoisted_27, [
                      _createElementVNode("div", null, [
                        _createElementVNode("h5", _hoisted_28, _toDisplayString(_ctx.$t("purchase_page.purchased_items")), 1),
                        _createElementVNode("p", _hoisted_29, _toDisplayString(_ctx.$t("purchase_page.review_purchase_products")), 1)
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_30, [
                      _createElementVNode("table", _hoisted_31, [
                        _createElementVNode("thead", null, [
                          _createElementVNode("tr", null, [
                            _cache[12] || (_cache[12] = _createElementVNode("th", null, "#", -1)),
                            _createElementVNode("th", null, _toDisplayString(_ctx.$t("purchase_page.product")), 1),
                            _createElementVNode("th", null, _toDisplayString(_ctx.$t("purchase_page.warehouse")), 1),
                            _createElementVNode("th", _hoisted_32, _toDisplayString(_ctx.$t("purchase_page.qty")), 1),
                            _createElementVNode("th", _hoisted_33, _toDisplayString(_ctx.$t("purchase_page.unit_cost")), 1),
                            _createElementVNode("th", _hoisted_34, _toDisplayString(_ctx.$t("purchase_page.subtotal")), 1)
                          ])
                        ]),
                        _createElementVNode("tbody", null, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.localPurchase.items || [], (item, index) => {
                            return (_openBlock(), _createElementBlock("tr", {
                              key: item.id || `${item.product_id}-${index}`
                            }, [
                              _createElementVNode("td", null, _toDisplayString(index + 1), 1),
                              _createElementVNode("td", null, [
                                _createElementVNode("div", _hoisted_35, _toDisplayString(item.product_name || _ctx.$t("purchase_page.not_available_short")), 1),
                                _createElementVNode("div", _hoisted_36, _toDisplayString(item.product_code || _ctx.$t("purchase_page.not_available_short")), 1)
                              ]),
                              _createElementVNode("td", null, _toDisplayString(item.warehouse_name || _ctx.localPurchase.warehouse_name || _ctx.$t("purchase_page.not_available_short")), 1),
                              _createElementVNode("td", _hoisted_37, _toDisplayString(item.quantity), 1),
                              _createElementVNode("td", _hoisted_38, _toDisplayString(_ctx.formatMoney(item.unit_cost)), 1),
                              _createElementVNode("td", _hoisted_39, _toDisplayString(_ctx.formatMoney(item.subtotal)), 1)
                            ]))
                          }), 128)),
                          (!(_ctx.localPurchase.items || []).length)
                            ? (_openBlock(), _createElementBlock("tr", _hoisted_40, [
                                _createElementVNode("td", _hoisted_41, _toDisplayString(_ctx.$t("purchase_page.no_purchase_items_available")), 1)
                              ]))
                            : _createCommentVNode("", true)
                        ])
                      ])
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_42, [
                  _createElementVNode("div", _hoisted_43, [
                    _createElementVNode("div", _hoisted_44, [
                      _createElementVNode("div", null, [
                        _createElementVNode("h5", _hoisted_45, _toDisplayString(_ctx.$t("purchase_page.payment_activity")), 1),
                        _createElementVNode("p", _hoisted_46, _toDisplayString(_ctx.$t("purchase_page.track_purchase_payments")), 1)
                      ]),
                      (_ctx.balanceDue > 0)
                        ? (_openBlock(), _createElementBlock("button", {
                            key: 0,
                            class: "btn btn-primary btn-sm add-payment-btn",
                            onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.startCreatePayment && _ctx.startCreatePayment(...args)))
                          }, [
                            _cache[13] || (_cache[13] = _createElementVNode("i", { class: "ri-add-line me-1" }, null, -1)),
                            _createTextVNode(" " + _toDisplayString(_ctx.$t("purchase_page.add_payment")), 1)
                          ]))
                        : _createCommentVNode("", true)
                    ]),
                    _createElementVNode("div", _hoisted_47, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.sortedPayments, (payment) => {
                        return (_openBlock(), _createElementBlock("div", {
                          key: payment.id,
                          class: "payment-item"
                        }, [
                          _createElementVNode("div", null, [
                            _createElementVNode("div", _hoisted_48, _toDisplayString(payment.method?.name || payment.paid_by || _ctx.$t("purchase_page.payment")), 1),
                            _createElementVNode("div", _hoisted_49, [
                              _createTextVNode(_toDisplayString(_ctx.formatDate(payment.created_at)) + " ", 1),
                              (payment.note)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_50, "• " + _toDisplayString(payment.note), 1))
                                : _createCommentVNode("", true)
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_51, [
                            _createElementVNode("div", _hoisted_52, _toDisplayString(_ctx.formatMoney(payment.amount)), 1),
                            _createElementVNode("div", _hoisted_53, [
                              _createElementVNode("button", {
                                class: "btn btn-sm btn-light",
                                onClick: ($event: any) => (_ctx.startEditPayment(payment))
                              }, _toDisplayString(_ctx.$t("purchase_page.edit")), 9, _hoisted_54),
                              _createElementVNode("button", {
                                class: "btn btn-sm btn-outline-danger",
                                onClick: ($event: any) => (_ctx.removePayment(payment))
                              }, _toDisplayString(_ctx.$t("purchase_page.delete")), 9, _hoisted_55)
                            ])
                          ])
                        ]))
                      }), 128)),
                      (!_ctx.sortedPayments.length)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_56, [
                            _cache[14] || (_cache[14] = _createElementVNode("div", { class: "payment-empty-icon" }, [
                              _createElementVNode("i", { class: "ri-wallet-3-line" })
                            ], -1)),
                            _createElementVNode("h6", _hoisted_57, _toDisplayString(_ctx.$t("purchase_page.no_payments_yet")), 1),
                            _createElementVNode("p", _hoisted_58, _toDisplayString(_ctx.$t("purchase_page.no_payment_activity_yet")), 1)
                          ]))
                        : _createCommentVNode("", true)
                    ])
                  ]),
                  (_ctx.showPaymentForm)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_59, [
                        _createElementVNode("div", _hoisted_60, [
                          _createElementVNode("div", null, [
                            _createElementVNode("h5", _hoisted_61, _toDisplayString(_ctx.editingPaymentId ? _ctx.$t("purchase_page.edit_payment") : _ctx.$t("purchase_page.add_payment")), 1),
                            _createElementVNode("p", _hoisted_62, _toDisplayString(_ctx.editingPaymentId ? _ctx.$t("purchase_page.update_payment_entry") : _ctx.$t("purchase_page.record_new_payment")), 1)
                          ]),
                          _createElementVNode("button", {
                            class: "btn btn-sm btn-light",
                            onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.resetPaymentForm && _ctx.resetPaymentForm(...args)))
                          }, _toDisplayString(_ctx.$t("common.cancel")), 1)
                        ]),
                        _createElementVNode("div", _hoisted_63, [
                          _createElementVNode("div", _hoisted_64, [
                            _createElementVNode("label", _hoisted_65, _toDisplayString(_ctx.$t("purchase_page.amount")), 1),
                            _withDirectives(_createElementVNode("input", {
                              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.paymentForm.amount) = $event)),
                              type: "number",
                              min: "0",
                              step: "0.01",
                              class: "form-control"
                            }, null, 512), [
                              [
                                _vModelText,
                                _ctx.paymentForm.amount,
                                void 0,
                                { number: true }
                              ]
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_66, [
                            _createElementVNode("label", _hoisted_67, _toDisplayString(_ctx.$t("purchase_page.method")), 1),
                            _withDirectives(_createElementVNode("select", {
                              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.paymentForm.method_id) = $event)),
                              class: "form-select payment-input"
                            }, [
                              _createElementVNode("option", _hoisted_68, _toDisplayString(_ctx.$t("purchase_page.select_payment_method")), 1),
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.paymentMethods, (method) => {
                                return (_openBlock(), _createElementBlock("option", {
                                  key: method.id,
                                  value: method.id
                                }, _toDisplayString(method.name), 9, _hoisted_69))
                              }), 128))
                            ], 512), [
                              [
                                _vModelSelect,
                                _ctx.paymentForm.method_id,
                                void 0,
                                { number: true }
                              ]
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_70, [
                            _createElementVNode("label", _hoisted_71, _toDisplayString(_ctx.$t("purchase_page.paid_by")), 1),
                            _withDirectives(_createElementVNode("input", {
                              "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.paymentForm.paid_by) = $event)),
                              type: "text",
                              class: "form-control payment-input",
                              placeholder: _ctx.$t('purchase_page.paid_by_placeholder')
                            }, null, 8, _hoisted_72), [
                              [_vModelText, _ctx.paymentForm.paid_by]
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_73, [
                            _createElementVNode("label", _hoisted_74, _toDisplayString(_ctx.$t("purchase_page.note")), 1),
                            _withDirectives(_createElementVNode("textarea", {
                              "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.paymentForm.note) = $event)),
                              rows: "3",
                              class: "form-control payment-input",
                              placeholder: _ctx.$t('purchase_page.optional_note')
                            }, null, 8, _hoisted_75), [
                              [_vModelText, _ctx.paymentForm.note]
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_76, [
                            _createElementVNode("button", {
                              class: "btn btn-primary w-100 payment-submit-btn",
                              disabled: _ctx.isSubmittingPayment,
                              onClick: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.submitPayment && _ctx.submitPayment(...args)))
                            }, [
                              (_ctx.isSubmittingPayment)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_78))
                                : _createCommentVNode("", true),
                              _createTextVNode(" " + _toDisplayString(_ctx.editingPaymentId ? _ctx.$t("purchase_page.update_payment") : _ctx.$t("purchase_page.save_payment")), 1)
                            ], 8, _hoisted_77)
                          ])
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  _createElementVNode("div", _hoisted_79, [
                    _createElementVNode("div", _hoisted_80, [
                      _createElementVNode("h5", _hoisted_81, _toDisplayString(_ctx.$t("purchase_page.purchase_totals")), 1)
                    ]),
                    _createElementVNode("div", _hoisted_82, [
                      _createElementVNode("span", null, _toDisplayString(_ctx.$t("purchase_page.subtotal")), 1),
                      _createElementVNode("strong", null, _toDisplayString(_ctx.formatMoney(_ctx.subtotalAmount)), 1)
                    ]),
                    _createElementVNode("div", _hoisted_83, [
                      _createElementVNode("span", null, [
                        _createTextVNode(_toDisplayString(_ctx.$t("purchase_page.tax")), 1),
                        (Number(_ctx.localPurchase.tax_rate || 0) > 0)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_84, " (" + _toDisplayString(Number(_ctx.localPurchase.tax_rate).toFixed(2).replace(/\.00$/, "")) + "%)", 1))
                          : _createCommentVNode("", true)
                      ]),
                      _createElementVNode("strong", null, _toDisplayString(_ctx.formatMoney(_ctx.localPurchase.tax || 0)), 1)
                    ]),
                    _createElementVNode("div", _hoisted_85, [
                      _createElementVNode("span", null, _toDisplayString(_ctx.$t("purchase_page.shipping")), 1),
                      _createElementVNode("strong", null, _toDisplayString(_ctx.formatMoney(_ctx.localPurchase.shipping || 0)), 1)
                    ]),
                    (Number(_ctx.localPurchase.discount || 0) > 0)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_86, [
                          _createElementVNode("span", null, _toDisplayString(_ctx.$t("purchase_page.discount")), 1),
                          _createElementVNode("strong", null, "-" + _toDisplayString(_ctx.formatMoney(_ctx.localPurchase.discount || 0)), 1)
                        ]))
                      : _createCommentVNode("", true),
                    _createElementVNode("div", _hoisted_87, [
                      _createElementVNode("span", null, _toDisplayString(_ctx.$t("purchase_page.grand_total")), 1),
                      _createElementVNode("strong", null, _toDisplayString(_ctx.formatMoney(_ctx.localPurchase.grand_total)), 1)
                    ])
                  ])
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_88, [
              _createElementVNode("div", _hoisted_89, [
                _createElementVNode("div", _hoisted_90, [
                  _cache[15] || (_cache[15] = _createElementVNode("div", { class: "invoice-logo" }, [
                    _createElementVNode("img", {
                      src: _imports_0,
                      alt: "Logo",
                      class: "mb-10",
                      style: {"max-height":"50px"}
                    }),
                    _createElementVNode("p", { class: "fs-12 text-paragraph mb-0" }, "ProCare Solution")
                  ], -1)),
                  _createElementVNode("div", _hoisted_91, [
                    _createElementVNode("h1", _hoisted_92, _toDisplayString(_ctx.$t("purchase_page.invoice")), 1),
                    _createElementVNode("p", _hoisted_93, _toDisplayString(_ctx.$t("purchase_page.invoice_no")) + ": " + _toDisplayString(_ctx.localPurchase.ref), 1)
                  ])
                ]),
                _createElementVNode("div", _hoisted_94, [
                  _createElementVNode("div", _hoisted_95, [
                    _createElementVNode("p", _hoisted_96, _toDisplayString(_ctx.$t("purchase_page.bill_to")) + ":", 1),
                    _createElementVNode("h6", _hoisted_97, _toDisplayString(_ctx.localPurchase.supplier_name), 1),
                    _createElementVNode("p", _hoisted_98, _toDisplayString(_ctx.$t("purchase_page.supplier_code")) + ": " + _toDisplayString(_ctx.localPurchase.supplier_code || _ctx.$t("purchase_page.not_available_short")), 1),
                    (_ctx.localPurchase.warehouse_name)
                      ? (_openBlock(), _createElementBlock("p", _hoisted_99, _toDisplayString(_ctx.$t("purchase_page.warehouse")) + ": " + _toDisplayString(_ctx.localPurchase.warehouse_name), 1))
                      : _createCommentVNode("", true)
                  ]),
                  _createElementVNode("div", _hoisted_100, [
                    _createElementVNode("p", _hoisted_101, _toDisplayString(_ctx.$t("purchase_page.total_due")) + ":", 1),
                    _createElementVNode("h4", _hoisted_102, _toDisplayString(_ctx.formatMoney(_ctx.balanceDue)), 1),
                    _createElementVNode("p", _hoisted_103, _toDisplayString(_ctx.$t("purchase_page.date")) + ": " + _toDisplayString(_ctx.formatDate(_ctx.localPurchase.created_at || _ctx.localPurchase.date)), 1)
                  ])
                ]),
                _createElementVNode("div", _hoisted_104, [
                  _createElementVNode("table", _hoisted_105, [
                    _createElementVNode("thead", null, [
                      _createElementVNode("tr", _hoisted_106, [
                        _cache[16] || (_cache[16] = _createElementVNode("th", {
                          class: "text-center py-2 fs-14 fw-bold text-uppercase",
                          style: {"width":"50px"}
                        }, "#", -1)),
                        _createElementVNode("th", _hoisted_107, _toDisplayString(_ctx.$t("purchase_page.description")), 1),
                        _createElementVNode("th", _hoisted_108, _toDisplayString(_ctx.$t("purchase_page.store")), 1),
                        _createElementVNode("th", _hoisted_109, _toDisplayString(_ctx.$t("purchase_page.qty")), 1),
                        _createElementVNode("th", _hoisted_110, _toDisplayString(_ctx.$t("purchase_page.cost")), 1),
                        _createElementVNode("th", _hoisted_111, _toDisplayString(_ctx.$t("purchase_page.total")), 1)
                      ])
                    ]),
                    _createElementVNode("tbody", null, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.localPurchase.items || [], (item, index) => {
                        return (_openBlock(), _createElementBlock("tr", {
                          key: item.id || `${item.product_id}-print-${index}`
                        }, [
                          _createElementVNode("td", _hoisted_112, _toDisplayString(index + 1), 1),
                          _createElementVNode("td", _hoisted_113, [
                            _createElementVNode("div", _hoisted_114, _toDisplayString(item.product_name), 1)
                          ]),
                          _createElementVNode("td", _hoisted_115, _toDisplayString(item.warehouse_name || _ctx.localPurchase.warehouse_name), 1),
                          _createElementVNode("td", _hoisted_116, _toDisplayString(item.quantity), 1),
                          _createElementVNode("td", _hoisted_117, _toDisplayString(_ctx.formatMoney(item.unit_cost)), 1),
                          _createElementVNode("td", _hoisted_118, _toDisplayString(_ctx.formatMoney(item.subtotal)), 1)
                        ]))
                      }), 128))
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_119, [
                  _createElementVNode("div", _hoisted_120, [
                    _createElementVNode("div", _hoisted_121, [
                      _createElementVNode("h6", _hoisted_122, _toDisplayString(_ctx.$t("purchase_page.payment_info")) + ":", 1),
                      _createElementVNode("p", _hoisted_123, [
                        _createElementVNode("span", _hoisted_124, _toDisplayString(_ctx.$t("purchase_page.status")) + ":", 1),
                        _createElementVNode("span", _hoisted_125, _toDisplayString(_ctx.formatPaymentStatus(_ctx.localPurchase.payment_status)), 1)
                      ]),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.sortedPayments, (payment) => {
                        return (_openBlock(), _createElementBlock("p", {
                          class: "fs-12 text-paragraph mb-1",
                          key: payment.id || payment.created_at
                        }, [
                          _createElementVNode("span", _hoisted_126, _toDisplayString(_ctx.$t("purchase_page.payment")) + ":", 1),
                          _createTextVNode(" " + _toDisplayString(payment.method?.name || payment.paid_by || _ctx.$t("purchase_page.payment")) + " - " + _toDisplayString(_ctx.formatMoney(payment.amount)), 1)
                        ]))
                      }), 128))
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_127, [
                    _createElementVNode("div", _hoisted_128, [
                      _createElementVNode("div", _hoisted_129, [
                        _createElementVNode("span", _hoisted_130, _toDisplayString(_ctx.$t("purchase_page.sub_total")), 1),
                        _createElementVNode("span", _hoisted_131, _toDisplayString(_ctx.formatMoney(_ctx.subtotalAmount)), 1)
                      ]),
                      _createElementVNode("div", _hoisted_132, [
                        _createElementVNode("span", _hoisted_133, [
                          _createTextVNode(_toDisplayString(_ctx.$t("purchase_page.tax")), 1),
                          (Number(_ctx.localPurchase.tax_rate || 0) > 0)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_134, " (" + _toDisplayString(Number(_ctx.localPurchase.tax_rate).toFixed(2).replace(/\.00$/, "")) + "%)", 1))
                            : _createCommentVNode("", true)
                        ]),
                        _createElementVNode("span", _hoisted_135, _toDisplayString(_ctx.formatMoney(_ctx.localPurchase.tax || 0)), 1)
                      ]),
                      _createElementVNode("div", _hoisted_136, [
                        _createElementVNode("span", _hoisted_137, _toDisplayString(_ctx.$t("purchase_page.shipping")), 1),
                        _createElementVNode("span", _hoisted_138, _toDisplayString(_ctx.formatMoney(_ctx.localPurchase.shipping || 0)), 1)
                      ]),
                      (Number(_ctx.localPurchase.discount || 0) > 0)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_139, [
                            _createElementVNode("span", _hoisted_140, _toDisplayString(_ctx.$t("purchase_page.discount")), 1),
                            _createElementVNode("span", _hoisted_141, "-" + _toDisplayString(_ctx.formatMoney(_ctx.localPurchase.discount || 0)), 1)
                          ]))
                        : _createCommentVNode("", true),
                      _createElementVNode("div", _hoisted_142, [
                        _createElementVNode("span", _hoisted_143, _toDisplayString(_ctx.$t("purchase_page.grand_total")), 1),
                        _createElementVNode("span", _hoisted_144, _toDisplayString(_ctx.formatMoney(_ctx.localPurchase.grand_total)), 1)
                      ]),
                      _createElementVNode("div", _hoisted_145, [
                        _createElementVNode("span", _hoisted_146, _toDisplayString(_ctx.$t("purchase_page.amount_paid")), 1),
                        _createElementVNode("span", _hoisted_147, _toDisplayString(_ctx.formatMoney(_ctx.localPurchase.paid)), 1)
                      ]),
                      _createElementVNode("div", _hoisted_148, [
                        _createElementVNode("span", _hoisted_149, _toDisplayString(_ctx.$t("purchase_page.balance_due")), 1),
                        _createElementVNode("span", _hoisted_150, _toDisplayString(_ctx.formatMoney(_ctx.balanceDue)), 1)
                      ])
                    ])
                  ])
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_151, [
              _createElementVNode("button", {
                class: "btn btn-light",
                onClick: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => (_ctx.handlePrint && _ctx.handlePrint(...args)))
              }, [
                _cache[17] || (_cache[17] = _createElementVNode("i", { class: "ri-printer-line me-1" }, null, -1)),
                _createTextVNode(" " + _toDisplayString(_ctx.$t("purchase_page.print")), 1)
              ]),
              _createElementVNode("button", {
                class: "btn btn-outline-danger",
                onClick: _cache[10] || (_cache[10] = 
//@ts-ignore
(...args) => (_ctx.handleDeletePurchase && _ctx.handleDeletePurchase(...args)))
              }, [
                _cache[18] || (_cache[18] = _createElementVNode("i", { class: "ri-delete-bin-line me-1" }, null, -1)),
                _createTextVNode(" " + _toDisplayString(_ctx.$t("purchase_page.delete_purchase")), 1)
              ]),
              _createElementVNode("button", {
                class: "btn btn-dark",
                onClick: _cache[11] || (_cache[11] = ($event: any) => (_ctx.$emit('close')))
              }, _toDisplayString(_ctx.$t("common.close")), 1)
            ])
          ])
        ])
      ]))
    : _createCommentVNode("", true)
}